import React, { useState } from 'react';
import Layout from '../../components/Layout';
import { getUserInfo } from '../../user';
import { Navigate } from 'react-router-dom';
import CustomerTable from '../../components/CustomerTable';
import CustomerModal from '../../components/CustomerModal';
import ContractModal from '../../components/ContractModal';

export default function Customers() {
  const [user, setUser] = React.useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [contractModalOpen, setContractModalOpen] = useState(false);
  const [contractCustomer, setContractCustomer] = useState(null);
  // The page is admin-only, so admins edit here (see CustomerModal for non-admins)
  const [editCustomer, setEditCustomer] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  React.useEffect(() => {
    getUserInfo().then(setUser);
  }, []);
  if (!user) return null;
  if (!Array.isArray(user.roles) || !user.roles.includes('admin')) return <Navigate to="/" replace />;
  return (
    <Layout>
      <h1 className="text-2xl font-bold mb-4">Customers</h1>
      <CustomerTable
        key={refreshKey}
        onCreateClick={() => { setEditCustomer(null); setModalOpen(true); }}
        onEdit={(customer) => { setEditCustomer(customer); setModalOpen(true); }}
        onCreateContract={({ customerId, customerName }) => {
          setContractCustomer({ customerId, customerName });
          setContractModalOpen(true);
        }}
      />
      <CustomerModal
        open={modalOpen}
        customer={editCustomer}
        isAdmin
        onClose={() => setModalOpen(false)}
        onCreated={() => { setModalOpen(false); setRefreshKey(k => k + 1); }}
        onUpdated={() => { setModalOpen(false); setRefreshKey(k => k + 1); }}
      />
      <ContractModal
        open={contractModalOpen}
        onClose={() => setContractModalOpen(false)}
        customerId={contractCustomer?.customerId}
        customerName={contractCustomer?.customerName}
        onCreated={() => {
          setContractModalOpen(false);
          setRefreshKey(k => k + 1);
        }}
      />
    </Layout>
  );
}
